import timeZones from "utilities/timeZones"
import React from "react"
import { Control, useController } from "react-hook-form"
import { SingleValue } from "chakra-react-select"
import Select, { SelectOption } from "components/Select"
import _ from "lodash"
import { Box, Flex, FormLabel } from "@chakra-ui/react"

type Props = {
  control: Control<any>
  label?: string
}

const TimeZoneSelect = ({ control, label }: Props) => {
  const timeZoneOptions = _.sortBy(timeZones, "numericOffset")
    .map(({ label: timeZoneLabel, timeZoneId }) => ({
      label: timeZoneLabel,
      value: timeZoneId,
    }))

  const { field } = useController({ name: "timezone", control })
  const selectedItem = timeZoneOptions.find((option) => option.value === field.value)

  return (
    <Flex mb={3} w="full" align="flex-end">
      {label && <FormLabel fontWeight="semibold" w="25%" htmlFor="timezone">{label}</FormLabel>}
      <Box w={label ? "100%" : "100%"}>
        <Select<SelectOption, false>
          value={selectedItem ?? null}
          name="timezone"
          options={timeZoneOptions}
          onChange={({ value }: SingleValue<any>) => field.onChange(value)}
        />
      </Box>
    </Flex>
  )
}

export default TimeZoneSelect
